import { createAsyncThunk } from "@reduxjs/toolkit";
import { WarehouseAxios } from "api/WarehouseAxios";
import { api } from "helpers/api_url";

export const fetchPendingSalesOrderReturn = createAsyncThunk(
  "warehouse/fetchPendingSalesOrderReturn",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    warehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    warehouse_id?: string;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }

    if (filters?.length) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (!filterField || filterValue === undefined || filterValue === null)
            return;

          // 🧠 Handle Date Range or Object Filters
          if (typeof filterValue === "object") {
            const { from_date, to_date, ...otherValues } = filterValue;

            // Append other fields (if any)
            Object.entries(otherValues).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
            });

            // Handle date range filters
            if (from_date) {
              params.append(`${filterField}_from`, String(from_date));
            }
            if (to_date) {
              params.append(`${filterField}_to`, String(to_date));
            }
          }

          // 📌 Handle Primitive Values (string / number / boolean)
          else {
            params.append(filterField, String(filterValue));
          }
        }
      );
    }

    const response: any = await WarehouseAxios.get(
      `${
        api?.warehouse?.item_inward?.sales_order_return_listing
      }?warehouse_id=${warehouse_id}&${params.toString()}`
    );
    // const response: any = await WarehouseAxios.get(
    //   `/dispatch/list/?${params.toString()}`
    // );

    return {
      data: response?.data?.data || [],
      rowCount: response.data.count || 0,
    };
  }
);

export const exportDraftRFQCSV = async () => {
  const response = await WarehouseAxios.get(
    "/purchase_request/list/?export=csv",
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "purchaseRequest.csv",
  };
};
